import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { format } from 'date-fns';
import StudentRecordFilter from '../../../shared/components/StudentRecordFilter';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import PendingRecordItem from './PendingRecordItem';
import AuditTab from './AuditTab';
import { colorCommunicationType } from '../../../shared/utils/smartutils';
import PendingRecordAll from './PendingRecordAll';

const PendencyColumn = (props) => {
  const {
    t,
    dispatch,
    onSelectionChange,
    onChangeSelectedTab,
    loadPendency,
    pendingRecords,
    onChangePendingRecords,
    lastStudentRecordFilter,
    selectedTab,
    pendencySummary,
  } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const onSelectionAppointmentChangeHandler = (
    event,
    itemIndex,
    pendingItem
  ) => {
    const updatedPendingRecords = { ...pendingRecords };
    const updatedPendingItem = { ...pendingItem };
    updatedPendingItem.selected = event.target.checked;
    updatedPendingRecords.appointments[itemIndex] = updatedPendingItem;
    onChangePendingRecords(updatedPendingRecords);
  };

  const onSelectionCommunicationChangeHandler = (
    event,
    itemIndex,
    pendingItem
  ) => {
    const updatedPendingRecords = { ...pendingRecords };
    const updatedPendingItem = { ...pendingItem };
    updatedPendingItem.selected = event.target.checked;
    updatedPendingRecords.communications[itemIndex] = updatedPendingItem;
    onChangePendingRecords(updatedPendingRecords);
  };

  const showAppointmentsPendingRecordsQuantity = () => {
    return pendingRecords.appointments.length
      ? `(${pendingRecords.appointments.length})`
      : `(${pendencySummary.routineRecordsPendency})`;
  };

  const showCommunicationPendingRecordsQuantity = () => {
    return pendingRecords.communications.length
      ? `(${pendingRecords.communications.length})`
      : `(${pendencySummary.communicationPendency})`;
  };

  const getCommunicationType = (type) => {
    return t(`communication.type-${type}`);
  };

  const getColorByCommunicationType = (type) => {
    return colorCommunicationType()[type];
  };

  const getDate = (date) => {
    return format(new Date(date), 'dd/MM/yyyy');
  };

  const getHourDate = (date) => {
    return format(new Date(date), 'HH:mm');
  };

  const changeAppointmentSelectedAll = (evt) => {
    const updatedPendingRecords = { ...pendingRecords };
    updatedPendingRecords.appointments = updatedPendingRecords.appointments.map(
      (rec) => ({
        ...rec,
        selected: evt.target.checked,
      })
    );
    onChangePendingRecords(updatedPendingRecords);
  };

  const changeCommunicationSelectedAll = (evt) => {
    const updatedPendingRecords = { ...pendingRecords };
    updatedPendingRecords.communications =
      updatedPendingRecords.communications.map((rec) => ({
        ...rec,
        selected: evt.target.checked,
      }));
    onChangePendingRecords(updatedPendingRecords);
  };

  const getSelectedAllCommunications = () => {
    return pendingRecords.communications.every((item) => item.selected);
  };

  const getSelectedAllAppointments = () => {
    return pendingRecords.appointments.every((item) => item.selected);
  };

  useEffect(() => {
    onSelectionChange(pendingRecords);
  }, [pendingRecords]);

  useEffect(() => {
    return () => {
      onChangePendingRecords({ appointments: [], communications: [] });
    };
  }, []);

  return (
    <div className="pendency-column">
      <StudentRecordFilter
        showItemsFilter={selectedTab === 0}
        showLoading={showLoading}
        hideLoading={hideLoading}
        showSyncFilter={false}
        showEmployeeFilter={false}
        filterClick={loadPendency}
        lastFilter={lastStudentRecordFilter}
      />
      <AuditTab
        activeTab={onChangeSelectedTab}
        tabOneLabel={
          <span>
            {t('general.appointment')}{' '}
            {showAppointmentsPendingRecordsQuantity()}
          </span>
        }
        tabTwoLabel={
          <span>
            {t('general.communications')}{' '}
            {showCommunicationPendingRecordsQuantity()}
          </span>
        }
        tabOne={
          <div className="pendency-list">
            {!!pendingRecords.appointments.length && (
              <PendingRecordAll
                onChange={changeAppointmentSelectedAll}
                checked={getSelectedAllAppointments()}
              />
            )}
            {pendingRecords.appointments.map((item, index) => (
              <PendingRecordItem
                itemIndex={index}
                pendingItem={item}
                key={item.id}
                tagValue={item.levelOne}
                title={item.studentName}
                date={item.dateNote}
                hourDate={item.hourNote}
                tagColor="#6a2b8b"
                onSelectHandler={onSelectionAppointmentChangeHandler}
              />
            ))}
          </div>
        }
        tabTwo={
          <div className="pendency-list">
            {!!pendingRecords.communications.length && (
              <PendingRecordAll
                onChange={changeCommunicationSelectedAll}
                checked={getSelectedAllCommunications()}
              />
            )}
            {pendingRecords.communications.map((item, index) => (
              <PendingRecordItem
                key={item.id}
                itemIndex={index}
                date={getDate(item.createdAtMili)}
                hourDate={getHourDate(item.createdAtMili)}
                title={item.title}
                tagValue={getCommunicationType(item.type)}
                pendingItem={item}
                tagColor={getColorByCommunicationType(item.type)}
                onSelectHandler={onSelectionCommunicationChangeHandler}
              />
            ))}
          </div>
        }
      />
    </div>
  );
};

PendencyColumn.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  loadPendency: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onChangeSelectedTab: PropTypes.func.isRequired,
  pendingRecords: PropTypes.shape({
    appointments: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
    communications: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  }).isRequired,
  onChangePendingRecords: PropTypes.func.isRequired,
  lastStudentRecordFilter: PropTypes.shape(PropTypes.shape).isRequired,
  selectedTab: PropTypes.number.isRequired,
  pendencySummary: PropTypes.shape(PropTypes.shape).isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
    pendencySummary: state.pendencySummary,
  }))(memo(PendencyColumn))
);
